/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

 import { BirthPlace, Code, Confirm, Country } from "src/refresh/service/constant";
 import { Util } from "src/refresh/service/Util";
 import { ItemList } from "../constant/item-list";
 import { AdditionalParentInfoExtVO, SLBRequestVO } from "../data/app-vo";
 import { AboutChild, Address, BaseAddress, Eligibility, Facility, InputData, ParentInfo } from "../data/input-data";
 import { BCSLBCreator } from "./BCSLBCreator";
 var show = console.log.bind( console );
 
 export class SLBRequstCreator extends BCSLBCreator {
 
        slbRequest:SLBRequestVO;
        constructor(protected items:ItemList, protected data:InputData, protected todayMMDD:string) {
                    super();
        }
 
        public create() : SLBRequestVO {
 
               this.slbRequest = new SLBRequestVO()
 
               let child:AboutChild        = this.data.aboutChild;
 
               this.setChildInfo(child);
               this.setAttendant(child);
               this.setWeight(child);
               this.setBirthPlace(child);
 
               this.slbRequest.birthType = Number(this.data.eligibility.birthType);  // multiple birth
               //this.slbRequest.birthSequence = 0 ; // this will be set after returned. using  index 
 
               this.setOtherInfo();
               this.setSupportDocument();
               this.setDefaultValue();
                          
               this.parentList();

               this.slbRequest.motherOccupation = child.isChildDeceased=='Y'?'':null;

               return this.slbRequest;
        }
 
        //------------------------------------------------------------
        private setChildInfo(child:AboutChild) {
 
               this.slbRequest.childSurname    = child.name.getSingleOrLast();
               this.slbRequest.childMiddleName = child.name.middle;
               this.slbRequest.childGivenName  = child.name.first;
 
               if ( child.isParentAgreeOnLastName == Confirm.YES ||
                    child.isParentAgreeOnSingleName == Confirm.YES )
                    this.slbRequest.lastNameAgreement = Confirm.YES;
 
               this.slbRequest.childSex    = child.gender;
               this.slbRequest.dateOfEvent = child.birthDay;
               this.slbRequest.isTraditionalCulture = this.getYesNull(child.name.chk_singleName);
        }
 
        //--------------------------------------------------------------------------------------------
        private setAttendant(child:AboutChild) {
 
                if ( child.attendentSingleName )  this.slbRequest.attendantSurname = child.attendentSingleName;
                else                              this.slbRequest.attendantSurname = child.attendentLastName;
 
                this.slbRequest.attendantGivenName = child.attendentFirstName;
                this.slbRequest.attendantDesignation      = child.attendentType;
                this.slbRequest.attendantDesignationOther = child.attendentTitle; 
        } 
 
        //--------------------------------------------------------------------------------------------
        private setWeight(child:AboutChild) {
             if ( child.grams ) this.slbRequest.weightOfChildGram  =  child.grams;
             else {
                   if ( !child.ounces ) child.ounces = 0;
                   if ( !child.pounds ) child.pounds = 0;
                   this.slbRequest.weightOfChildPound =  Math.round((child.pounds + child.ounces/16)*100)/100;
             }
        }
 
        //--------------------------------------------------------------------------------------------
        private setBirthPlace(child:AboutChild) {
 
                this.slbRequest.poeCity   = child.cityName;
                this.slbRequest.poeCounty = child.region;
 
                this.slbRequest.hospitalName = child.birthPlaceName;
 
               if ( child.birthPlaceType == BirthPlace.Hospital ) {
 
                    //------------------------------------------
                    this.slbRequest.eventPlaceType = 'H';

                    if ( child.birthPlaceCode != Code.NotFound ) {
                         let  facility:Facility = this.items.facilityList[child.birthPlaceCode];
                         if ( facility ) {
                              this.slbRequest.hospitalCode  = facility.facilityCode;   
                              this.slbRequest.poeStNumber   = facility.streetNumber;
                              this.slbRequest.poeStName     = facility.streetName;
                              this.slbRequest.poePostalCode = facility.postalCode;
                         } 
                    }
               }
               else
               if ( child.birthPlaceType == BirthPlace.BirthCenter ) {
                    this.slbRequest.eventPlaceType = 'H';
               }
               else
               if ( child.birthPlaceType == BirthPlace.Home ) { 
                    //------------------------------------------
                    this.slbRequest.eventPlaceType = 'R';
                    this.slbRequest.poeStNumber  = child.birthStreetNumber;
                    this.slbRequest.poeStName    = child.birthStreetName;
               }
               else
               if ( child.birthPlaceType == BirthPlace.Other )  {
                    //------------------------------------------
                    this.slbRequest.eventPlaceType = 'O';
                    this.slbRequest.poeStNumber  = child.birthStreetNumber;
                    this.slbRequest.poeStName    = child.birthStreetName;
                    this.slbRequest.poeOtherAddDetail = this.slbRequest.hospitalName;
               }
               else this.slbRequest.eventPlaceType = 'U';
 
               if ( child.cityName )
                    this.slbRequest.poeCityGeocode = this.items.geoCodeNameList[child.cityName.toUpperCase()];
        }
 
        //--------------------------------------------------------------------------------------------
        private setOtherInfo() {

               let eligibility:Eligibility = this.data.eligibility;
            
               if ( eligibility.isOtherCertifyingBirth == Confirm.YES ) {
                    this.slbRequest.otherInformantCertPresent = Confirm.YES;
                    this.slbRequest.informantGivenName  = eligibility.otherFirstName;
                    this.slbRequest.informantSurname    = eligibility.otherLastName;
               }
               // it has nothing to do with eligibility.isOtherCertifyingBirth
               this.slbRequest.organizationInformantName = this.data.orderOfBC.organizationForOther;     
        }

        //--------------------------------------------------------------------------------------------
        private setSupportDocument() {
                let eligibility = this.data.eligibility;
                
                this.slbRequest.isBirthSurrogate  = this.getYesNull(eligibility.isBornThroughSurrogacy);
                this.slbRequest.isOtherCertifying = this.getYesNull(eligibility.isOtherCertifyingBirth);
                this.slbRequest.isIncapableOfCertifying = this.getYesNull(eligibility.isUnableToCertify);

                //this.slbRequest.isNonHospitalLocation   = this.getYesNull(eligibility.deliveredByOther);
                let attendentType = this.data.aboutChild.attendentType;
                this.slbRequest.isNonHospitalLocation = attendentType == 'O'?Confirm.YES:null;
               // NonHospitalLocation=Was the child delivered by a person other than a doctor or midwife?
               //    deliveredByOther=Was the child delivered by a person other than a doctor or midwife?
        }
 
        //--------------------------------------------------------------------------------------------
        private getYesNull(value):string {
                if ( Confirm.YES == value ) return value;
                return null;
        }
 
        //--------------------------------------------------------------------------------------------
        private setDefaultValue() {
               this.slbRequest.certificationIndicator = 'Y';
               this.slbRequest.modifiedBy = 'webvision';
        }

        //====================================================================================
        private parentList() {

             let parentList = this.data.parentList;

             this.createMother(parentList[0]);

             let hasFather:boolean = false;
             let hasParent3:boolean = false;
             let hasParent4:boolean = false;
 
             for ( let i = 1; i < this.data.eligibility.listedParentCount; i++ ) {
 
                   let  parent = parentList[i];
                   if ( !hasFather ) {
                         hasFather = true;
                         this.createFather(parent);
                   }
                   else
                   if ( !hasParent3 ) {
                         hasParent3 = true;
                         this.createParent3(parent);
                   }
                   else
                   if ( !hasParent4 ) {
                         hasParent4 = true;
                         this.createParent4(parent);
                   }
             }
        }
 
        //----------------------------------------------------------------------
        private createMother(parent:ParentInfo) {
 
               this.slbRequest.motherParentType = Number(parent.parentType);
 
               this.slbRequest.motherSurname      = parent.name.getSingleOrLast();
               this.slbRequest.motherGivenName    = parent.name.first;
               this.slbRequest.motherMiddleName   = parent.name.middle;
               this.slbRequest.motherOtherSurname = parent.previousLastName;
               this.slbRequest.motherMaidenName   = parent.lastNameAtBirth;
 
               let  pob = parent.placeOfBirth;
               this.slbRequest.motherPobCity = pob.city;    
               this.setMotherCountry(pob);
 
               this.slbRequest.isMotherLastNameAgreed = parent.isLastNameAgreed;
               this.slbRequest.motherCertPresent      = parent.isCertifyingParent;
 
               this.slbRequest.motherDateOfBirth = parent.whenParentBorn;
               this.slbRequest.motherAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);
               this.slbRequest.motherMaritalStatus = parent.maritalStatus;
               //---------------------------------------------------------------
               this.setMotherResAddress();
               this.setMotherMailAddress();
 
               this.slbRequest.gestationPeriod   = parent.pregnancyDuration;
               this.slbRequest.childrenLiveborn  = !parent.howManyLiveborn?0:parent.howManyLiveborn;
               this.slbRequest.childrenStillborn = !parent.howManyStillborn?0:parent.howManyStillborn;
        }
 
        //----------------------------------------------------------------------------------------
        private setMotherMailAddress() {
 
                if ( this.data.contact.isParentSameAddr == Confirm.YES )  return;
                
                let contact = this.data.contact;
                let mailAddr:Address = contact.address;
 
                this.slbRequest.motherMailPhoneNumber = contact.phoneNumber();
                this.slbRequest.motherDayPhoneNumber  = contact.dayTimeNumber();
 
                this.slbRequest.motherMailAddStNumber  = mailAddr.streetNumber;
                this.slbRequest.motherMailAddStName    = mailAddr.streetName;
                this.slbRequest.motherMailAddAptNumber = mailAddr.unit;   
 
                this.slbRequest.motherMailAddCity     = mailAddr.base.city; 
                this.slbRequest.motherMailCountryCode =  this.getCountryCode(mailAddr.base);        // province or country or -2
                this.slbRequest.motherMailCountry     =  this.getProvinceOrCountry(mailAddr.base);  // provice+country || 
                                                                                                    // lookup.country  || otherCountry
                this.slbRequest.motherMailDeliveryMode = mailAddr.deliveryMode;
                this.slbRequest.motherMailRouteNumber  = this.getDeliveryAddrorPOBox(mailAddr);
                this.slbRequest.motherMailPostalCode   = mailAddr.postalCode;
 
                if ( mailAddr.buzz ) this.slbRequest.motherMailBuzzerNumber = Number(mailAddr.buzz);
        }
 
        //----------------------------------------------------------------------------------------
        private setMotherResAddress() {
 
                if ( !this.data.motherContact  ) return;

                this.slbRequest.motherMailAddSameInd = this.data.contact.isParentSameAddr;
                if ( this.data.contact.isParentSameAddr == Confirm.YES ) 
                     this.data.motherContact = this.data.contact; 
                
                let motherAddr:Address = this.data.motherContact.address;
 
                this.slbRequest.motherResStreetNumber = motherAddr.streetNumber;
                this.slbRequest.motherResStreetName   = motherAddr.streetName;
                this.slbRequest.motherResAptNumber    = motherAddr.unit;   // no buzz in res addr
 
                this.slbRequest.motherResCity = motherAddr.base.city;
                this.slbRequest.motherResCountryCode =  this.getCountryCode(motherAddr.base);
                this.slbRequest.motherResCountry     =  this.getProvinceOrCountry(motherAddr.base);
 
                this.slbRequest.motherResGeocode = this.items.geoCodeList[motherAddr.base.city.toUpperCase()];
 
                this.slbRequest.motherResDeliveryMode = motherAddr.deliveryMode;
                this.slbRequest.motherResRouteNumber  = this.getDeliveryAddrorPOBox(motherAddr);
                this.slbRequest.motherResPostalCode   = motherAddr.postalCode;
        }
 
        //--------------------------------------------------------------------------------------
        private createFather(parent:ParentInfo) {
 
               this.slbRequest.fatherInfoPresentInd = Confirm.YES;
               this.slbRequest.fatherParentType = Number(parent.parentType);
 
               this.slbRequest.fatherSurname    = parent.name.getSingleOrLast();
               this.slbRequest.fatherGivenName  = parent.name.first;
               this.slbRequest.fatherMiddleName = parent.name.middle;
               this.slbRequest.fatherOtherSurname   = parent.previousLastName;
               this.slbRequest.fatherSurnameAtBirth = parent.lastNameAtBirth;
 
               let  pob = parent.placeOfBirth;
               this.slbRequest.fatherPobCity = pob.city;    // not.from.ng-select
               this.setFatherCountry(pob);
 
               this.slbRequest.isFatherLastNameAgreed = parent.isLastNameAgreed;
               this.slbRequest.fatherCertPresent = parent.isCertifyingParent;
 
               this.slbRequest.fatherAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);
               this.slbRequest.fatherDateOfBirth = parent.whenParentBorn;
        }
 
        //--------------------------------------------------------------------------------------
        private createParent3(parent:ParentInfo) {
 
               let parent3 = new AdditionalParentInfoExtVO();
               this.slbRequest.parent3 = parent3;
               this.slbRequest.parent3InfoPresentInd = Confirm.YES;
 
               parent3.parentType = Number(parent.parentType);
 
               parent3.parentSurname    = parent.name.getSingleOrLast();
               parent3.parentGivenName  = parent.name.first;
               parent3.parentMiddleName = parent.name.middle;
               parent3.parentPreviousName = parent.previousLastName;
               parent3.parentNameAtBirth  = parent.lastNameAtBirth;
 
               let  pob = parent.placeOfBirth;
               this.setParentCountry(pob,parent3);
 
               parent3.isLastNameAgreed = parent.isLastNameAgreed;
               parent3.isCertificationPresent = parent.isCertifyingParent== 'Y';
 
               parent3.parentAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);
               parent3.parentDateOfBirth = parent.whenParentBorn;
        }
 
        //--------------------------------------------------------------------------------------
        private createParent4(parent:ParentInfo) {
 
             let parent4 = new AdditionalParentInfoExtVO();
 
             this.slbRequest.parent4 = parent4;
             this.slbRequest.parent4InfoPresentInd = Confirm.YES;
 
             parent4.parentType = Number(parent.parentType);
 
             parent4.parentSurname    = parent.name.getSingleOrLast();
             parent4.parentGivenName  = parent.name.first;
             parent4.parentMiddleName = parent.name.middle;
             parent4.parentPreviousName = parent.previousLastName;
             parent4.parentNameAtBirth  = parent.lastNameAtBirth;
 
             let  pob = parent.placeOfBirth;
             this.setParentCountry(pob,parent4);
 
             parent4.isLastNameAgreed = parent.isLastNameAgreed;
             parent4.isCertificationPresent = parent.isCertifyingParent== 'Y';
 
             parent4.parentAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);
             parent4.parentDateOfBirth = parent.whenParentBorn;
        }   
 
 
 
        //========================================================================================
        protected getProvinceOrCountry(base:BaseAddress):string {
                if ( base.country == Country.CANADA ) {
                     return this.getCountryWithProvinceName(base);
                }
                else
                if ( base.country == Code.NotFound ) 
                       return base.otherCountry;
                else  {
                        return this.getCountryName(base.country);
                }
        }
        
 
        //----------------------------------------------------------------------------------------
        private getCountryWithProvinceName(pob:BaseAddress) {
                let province = this.items.provinceList.get(pob.province);
                    province += ", CANADA";
                return province;
        }
 
        //----------------------------------------------------------------------------------------
        private setMotherCountry(pob:BaseAddress) {
 
                if ( pob.country != Code.NotFound ) {
 
                      if ( pob.country == Country.CANADA ) {
                           this.slbRequest.motherPobCountryCode = Number(pob.province); 
                           this.slbRequest.motherPobCountry = this.getCountryWithProvinceName(pob); // "Ontario,Canada"
                      }
                      else {
                           this.slbRequest.motherPobCountryCode = Number(pob.country); 
                           this.slbRequest.motherPobCountry = this.getCountryName(pob.country);
                      }
                 }
                 else { 
                       this.slbRequest.motherPobCountry = pob.otherCountry;
                       this.slbRequest.motherPobCountryCode = null;
                 }
        }
 
 
        //----------------------------------------------------------------------------------------
        private setFatherCountry(pob:BaseAddress) {
             if ( pob.country != Code.NotFound ) {
 
                   if ( pob.country == Country.CANADA ) {
                        this.slbRequest.fatherPobCountryCode = Number(pob.province); 
                        this.slbRequest.fatherPobCountry = this.getCountryWithProvinceName(pob);  // "Ontario,Canada"
                   }
                   else {
                        this.slbRequest.fatherPobCountryCode = Number(pob.country); 
                        this.slbRequest.fatherPobCountry = this.getCountryName(pob.country);
                   }
              }
              else  {
                    this.slbRequest.fatherPobCountry = pob.otherCountry;
                    this.slbRequest.fatherPobCountryCode = null;
              }
        }
        //----------------------------------------------------------------------------------------
        private setParentCountry(pob:BaseAddress, parent:AdditionalParentInfoExtVO) {
 
                parent.parentPlaceOfBirthCity = pob.city;
 
                if ( pob.country != Code.NotFound ) {
 
                      if ( pob.country == Country.CANADA ) {
                           parent.parentPlaceOfBirthCountry = Number(pob.province); 
                           parent.parentPOBCountry = this.getCountryWithProvinceName(pob); // "Ontario,Canada"
                      }
                      else {
                           parent.parentPlaceOfBirthCountry = Number(pob.country); 
                           parent.parentPOBCountry = this.getCountryName(pob.country);
                      }
                 }
                 else { 
                       parent.parentPOBCountry = pob.otherCountry;
                       parent.parentPlaceOfBirthCountry = null;
                 }
        }

        private getCountryName(countryCode:any) {
            let country:string = this.items.countryList.get(countryCode);

            if ( !country ) return '';

            country = country.trim();

            if ( country.endsWith(")") ) country = country.substring(0,country.length-1);
                  
            country = country.replace(/([\/\\\{\}\(\)\*\+\<\>%;])/g, ",");
            return country;
        }
 }